import { render, staticRenderFns } from "./ShareContactSuggestion.vue?vue&type=template&id=33bbca95&scoped=true"
import script from "./ShareContactSuggestion.vue?vue&type=script&lang=ts"
export * from "./ShareContactSuggestion.vue?vue&type=script&lang=ts"
import style0 from "./ShareContactSuggestion.vue?vue&type=style&index=0&id=33bbca95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbca95",
  null
  
)

export default component.exports